<template>
  <div class="progresive">
    <div v-if="loading">
      <div class="progresive__container">
        <div class="progresive__loader"></div>
        <SfHeading v-if="showText" class="progresive__info" :level="4" :title="text" />
      </div>
    </div>
    <slot v-else />
  </div>
</template>

<script>
import { SfHeading } from '@storefront-ui/vue';

export default {
  name: 'Loader',
  components: {
    SfHeading,
  },
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    text: {
      type: String,
      default: 'Loading...',
    },
    showText: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@storefront-ui/shared/styles/helpers";

.progresive {
  &__container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin: 10px 0;
  }
  &__loader {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
    margin-bottom: 10px;
  }

  &__loader:after {
    content: " ";
    display: block;
    border-radius: 50%;
    width: 0;
    height: 0;
    margin: 8px;
    box-sizing: border-box;
    border: 32px solid #fff;
    border-color: var(--_c-blue-primary) transparent var(--_c-blue-primary)
      transparent;
    animation: progresive-container__loader 2s infinite;
  }

  @keyframes progresive-container__loader {
    0% {
      transform: rotate(-45deg);
      animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    }
    50% {
      transform: rotate(315deg);
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }
    100% {
      transform: rotate(675deg);
    }
  }
}
</style>
